module.exports = __webpack_public_path__ + "093c7bba6836518b06e32042b65ce5be.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/news/temp.jpg
// module id = 561
// module chunks = 0